import { XMarkIcon } from '@heroicons/react/20/solid';
import type React from 'react';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

const Alert = ({
  children,
  color,
  onClose,
}: {
  children: (React.ReactNode | JSX.Element)[] | React.ReactNode | JSX.Element | string;
  color?: 'red' | 'black';
  onClose?: React.MouseEventHandler<SVGSVGElement>;
}) => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) {
    return null;
  }

  return (
    <aside
      className={twMerge(
        'flex flex-row items-start justify-between bg-amber-50 p-4 dark:bg-amber-950/40',
        color === 'red' && 'bg-red-50 dark:bg-red-950/40',
        color === 'black' && 'bg-zinc-800 dark:bg-zinc-600',
      )}
    >
      <div>{children}</div>
      <button onClick={() => setIsDismissed(true)} className="pl-2" aria-label="Dismiss message">
        <XMarkIcon
          className={twMerge(
            'size-5 text-amber-700 dark:text-amber-300',
            color === 'red' && 'text-red-700 dark:text-red-300',
            color === 'black' && 'text-white',
          )}
          aria-hidden="true"
          onClick={onClose}
        />
      </button>
    </aside>
  );
};

export default Alert;
